import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  urlBase = environment.baseUrlAPI;

  constructor(private http: HttpClient) { }


  obtener(id: string): Observable<any> {
    return this.http.get(environment.baseUrlAPI + 'generar/' + id);
  }

  downloadFile(codigo: string) {
    const url = this.urlBase + `descargar.php?codigo=${codigo}`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
